import dayjs from 'dayjs'
import { Gig } from '../data/gigs'

const GigList = ({ gigs, past = false }: { gigs: Gig[], past?: boolean }) => (
    <ul className={`gig-list ${past ? 'gig-list--past' : ''}`}>
        {gigs.map((gig) => {
            const date = dayjs(gig.date)
            return (
                <li className='gig' key={`${gig.date}-${gig.venue}`}>
                    <div className='gig__date'>
                        <span className='gig__day'>{date.format('DD MMM')}</span>
                        <span className='gig__year'>{date.format('ddd YYYY')}</span>
                    </div>
                    <span className='gig__venue'>{gig.venue}</span>
                    <span className='gig__city'>{gig.city}</span>
                    <span className='gig__note'>{gig.note}</span>
                </li>
            )
        })}
    </ul>
)

export default GigList
